const SIZES = {
  sm: {
    button: "w-36 h-12",
    iconSize: "w-7 h-7",
    text: "text-sm",
  },
  base: {
    button: "w-40 h-14",
    iconSize: "w-8 h-8",
    text: "text-base",
  },
  lg: {
    button: "w-46 h-18",
    iconSize: "w-9 h-9",
    text: "text-md",
  },
  full: {
    button: "w-full h-full",
    iconSize: "w-9 h-9",
    text: "text-md",
  },
};

export { SIZES };
